// Header.js
import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import LoginModal from './LoginModal';
import '../styles/header.css';

const NAV_ITEMS = [
  { to: '/company', label: 'Company' },
  { to: '/services', label: 'Services' },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/insights', label: 'Insights' },
  { to: '/board', label: 'Board' },
  { to: '/contact', label: 'Contact' },
];

const Header = () => {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  // 로그인 상태 확인 (라우트 변경 시 재확인)
  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    setIsLoggedIn(!!token);
  }, [location.pathname]);

  // 스크롤 시 헤더 배경 전환
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // 라우트 변경 시 모바일 메뉴 닫기
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  // 모바일 메뉴 열림 시 body 스크롤 잠금
  useEffect(() => {
    document.body.classList.toggle('nav-open', menuOpen);
    return () => document.body.classList.remove('nav-open');
  }, [menuOpen]);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setIsLoginOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userInfo');
    setIsLoggedIn(false);
    alert('로그아웃되었습니다.');
  };

  const headerClass = [
    'site-header',
    isHome ? 'site-header--overlay' : '',
    scrolled ? 'is-scrolled' : '',
  ].filter(Boolean).join(' ');

  return (
    <header className={headerClass}>
      <div className="site-header__inner">
        <Link to="/" className="site-header__logo" aria-label="EZYLAB 홈">
          <img src="/images/logo.svg" alt="EZYLAB" />
        </Link>

        <nav className={`site-nav${menuOpen ? ' is-open' : ''}`} aria-label="주요 메뉴">
          <ul className="site-nav__list">
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) => `site-nav__link${isActive ? ' is-active' : ''}`}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="site-nav__auth">
            {isLoggedIn ? (
              <button type="button" className="btn btn--outline btn--sm" onClick={handleLogout}>
                로그아웃
              </button>
            ) : (
              <button type="button" className="btn btn--primary btn--sm" onClick={() => setIsLoginOpen(true)}>
                로그인
              </button>
            )}
          </div>
        </nav>

        <button
          type="button"
          className={`site-header__toggle${menuOpen ? ' is-open' : ''}`}
          aria-label={menuOpen ? '메뉴 닫기' : '메뉴 열기'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span></span><span></span><span></span>
        </button>
      </div>

      {menuOpen && <div className="site-nav__scrim" onClick={() => setMenuOpen(false)} />}

      {isLoginOpen && (
        <LoginModal
          closeModal={() => setIsLoginOpen(false)}
          onLogin={handleLoginSuccess}
        />
      )}
    </header>
  );
};

export default Header;
